<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Liste des agents</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color="AlertColor(type)"
                 :dismissible="true"
                 :value="true"
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-alert border="top" class="my-4" color="#F44336" dark dense v-if="errors.length>0"
                 v-model="alert">
          <h4 class="mt-2">{{ errors.length }}{{ " Erreur" | pluralize(errors.length) }}
            sur {{ excelData.length }} {{ "enregistrement"|pluralize(excelData.length) }}.
            Merci de corriger et de ne réimporter que les enregistrements ci-dessous rejetés, pour éviter
            tout doublon
          </h4>
          <v-row align="center">
            <v-col class="grow">
              <div :key="index" v-for="(error,index) in errors">
                <h5>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{ "Matricule (" + error.datas.userId + ") -> " + error.message }}
                </h5>
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn :elevation="1" @click="closeAlert" fab small
                     style="position:absolute;top:18px;right:12px">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>

        <!-- REMPLACÉ: Dialog de modification utilisant v-dialog au lieu de modal -->
        <v-dialog max-width="95%" persistent v-model="dialogModif">
          <v-card>
            <v-toolbar
                color="primary"
                dark
                flat>
              <v-text-field :id="dynamicID()" class="text--darken-3 mt-3"
                            dense
                            hide-details
                            readonly
                            rounded
                            style="width: 90%;"
                            v-model="modifier">
              </v-text-field>
              <v-spacer></v-spacer>
              <v-btn
                  @click="closeModif"
                  dark
                  fab
                  small>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text style="padding: 8px;">
              <v-alert :color=AlertColorS(typeS)
                       :dismissible=true
                       :value=true
                       border="top"
                       class="pre-formatted multi-line"
                       colored-border
                       elevation="2"
                       icon="check_circle"
                       v-if="typeS">
                {{ text }}
              </v-alert>
              <v-container fluid style="padding: 0;">
                <v-card-text style="padding: 0;">
                  <v-container style="padding: 8px;">
                    <v-stepper v-model="e6" vertical>
                      <v-stepper-step :complete="e6 > 1" :editable="true" step="1">
                        Informations du compte
                      </v-stepper-step>
                      <v-stepper-content step="1">
                        <v-row style="align-items: flex-end;">
                          <v-col cols="12" md="6" sm="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input align-center"
                                          disabled
                                          label="Matricule agent"
                                          v-model="editedItem.userId">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6" sm="12">
                            <v-select :items="companies"
                                      :disabled="true"
                                      class="centered-input align-center text-center"
                                      item-text="name"
                                      item-value="id"
                                      label="Entreprise"
                                      v-model="editedItem.walletCompanyId">
                              <template v-slot:selection="{ item }">
                                <span class="d-flex justify-center" style="width: 100%;">
                                  {{ item.name }}
                                </span>
                              </template>
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="6" sm="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input align-center"
                                          label="Prénom"
                                          v-model="editedItem.accountFirstname"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6" sm="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input align-center"
                                          label="Nom"
                                          v-model="editedItem.accountLastname"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="6" sm="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input align-center"
                                          label="Adresse"
                                          v-model="editedItem.accountAddress"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6" sm="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input align-center"
                                          label="Téléphone"
                                          type="number"
                                          v-model="editedItem.accountPhonenumber">
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="6" sm="12">
                            <v-select :items="brigadetypes"
                                      class="centered-input align-center text-center"
                                      item-text="type" item-value="type"
                                      label="Brigade"
                                      v-model="editedItem.brigade">
                              <template v-slot:selection="{ item }">
                                <span class="d-flex justify-center" style="width: 100%;">
                                  {{ item }}
                                </span>
                              </template>
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="6" sm="12">
                            <v-select :items="roles"
                                      class="centered-input align-center text-center"
                                      item-text="roleName"
                                      item-value="roleName"
                                      label="Fonction"
                                      v-model="editedItem.userRoles">
                              <template v-slot:selection="{ item }">
                                <span class="d-flex justify-center" style="width: 100%;">
                                  {{ item }}
                                </span>
                              </template>
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col cols="9" class="mx-auto">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input align-center"
                                          label="Email réel"
                                          v-model="editedItem.realAccountEmail"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-btn @click="e6 = 2" class="mb-2"
                               color="primary"><span
                            class="material-icons"> done_all </span></v-btn>
                      </v-stepper-content>
                    </v-stepper>
                  </v-container>
                </v-card-text>
                <v-card-actions style="padding: 8px;">
                  <v-spacer></v-spacer>
                  <v-btn :disabled="!FormIsValidModif && !loading" @click="creer(true)"
                         class="white--text"
                         color="#01579B" depressed>Modifier agent
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :disabled="disableMainBtn"
                            :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexportModele" block
                     class="custom-btn white--text"
                     color="#03A9F4" height="45px"
                     large>
                <v-icon class="mr-1">mdi-download-circle-outline</v-icon>
                <span> Export modèle </span>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexport" block class="custom-btn white--text"
                     color="#00BCD4"
                     height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export agents</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-dialog max-width="95%" persistent v-model="dialog">
                <template @mouseleave.native="hover = false" @mouseover.native="hover = true"
                          v-slot:activator="{ on }">
                  <v-btn :disabled="disableMainBtn" @click="init()" block
                         class="custom-btn white--text"
                         color="#009688" height="45px"
                         large v-on="on">
                    <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                    <span> Création agent </span>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar
                      color="#01579B"
                      dark
                      flat>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="close"
                        dark
                        fab
                        small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-tabs :grow=true background-color="#01579B" color="#f5f5f5" dark="" right
                          v-model="tab">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-1"> Via un formulaire</v-tab>
                    <v-tab href="#tab-2"> Via un fichier excel</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-1">
                      <v-card-text>
                        <v-container>
                          <v-stepper v-model="e6" vertical>
                            <v-stepper-step :complete="e6 > 1" :editable="true" step="1">
                              Informations du compte
                            </v-stepper-step>
                            <v-stepper-content step="1">
                              <v-row class="justify-center align-center">
                                <v-col cols="12" md="6" sm="12">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Matricule agent"
                                                style="width: 90%;"
                                                v-model="editedItem.userId">
                                  </v-text-field>
                                </v-col>
                                <!-- NOUVEAU: Sélecteur d'entreprise aligné avec le matricule -->
                                <v-col cols="12" md="6" sm="12">
                                  <v-select :items="companies"
                                            class="centered-input align-center text-center"
                                            item-text="name"
                                            item-value="id"
                                            label="Entreprise"
                                            style="width: 90%;"
                                            v-model="editedItem.walletCompanyId">
                                    <template v-slot:selection="{ item }">
                                      <span class="d-flex justify-center" style="width: 100%;">
                                        {{ item.name }}
                                      </span>
                                    </template>
                                  </v-select>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" md="6" sm="12">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Prénom"
                                                style="width: 90%;"
                                                v-model="editedItem.accountFirstname"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Nom"
                                                style="width: 90%;"
                                                v-model="editedItem.accountLastname"></v-text-field>
                                </v-col>
                              </v-row>
                              <!-- Dans le formulaire de MODIFICATION -->
                              <v-row>
                                <v-col cols="12" md="6" sm="12">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Adresse"
                                                style="width: 90%;"
                                                v-model="editedItem.accountAddress"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Téléphone"
                                                type="number"
                                                style="width: 90%;"
                                                v-model="editedItem.accountPhonenumber">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" md="6" sm="12">
                                  <v-select :items="brigadetypes"
                                            class="centered-input align-center text-center"
                                            item-text="type" item-value="type"
                                            label="Brigade"
                                            style="width: 90%;"
                                            v-model="editedItem.brigade">
                                    <template v-slot:selection="{ item }">
                                      <span class="d-flex justify-center" style="width: 100%;">
                                        {{ item }}
                                      </span>
                                    </template>
                                  </v-select>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <v-select :items="roles"
                                            class="centered-input align-center text-center"
                                            item-text="roleName"
                                            item-value="roleName"
                                            label="Fonction"
                                            style="width: 90%;"
                                            v-model="editedItem.userRoles">
                                    <template v-slot:selection="{ item }">
                                      <span class="d-flex justify-center" style="width: 100%;">
                                        {{ item }}
                                      </span>
                                    </template>
                                  </v-select>
                                </v-col>
                              </v-row>
                              <v-row class="justify-center">
                                <v-col cols="9" class="mx-auto">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Email réel"
                                                style="width: 90%;"
                                                v-model="editedItem.realAccountEmail"></v-text-field>
                                </v-col>
                              </v-row>
                              <v-btn @click="e6 = 2" class="mb-2"
                                     color="primary"><span
                                  class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                          </v-stepper>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!FormIsValid && !loading" @click="creer(false)"
                               class="white--text"
                               color="#01579B" depressed>Créer agent
                        </v-btn>
                      </v-card-actions>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                      <v-card v-if="!file">
                        <v-container v-if="loading">
                          <div class="text-center">
                            <v-progress-circular color="green" indeterminate>
                            </v-progress-circular>
                          </div>
                        </v-container>
                        <v-btn :disabled="!fileBtn" @click="onPickFile" block
                               class="mr-2 mb-2"
                               large style="color:#01579B; background-color:#F5F5F5"
                               v-if="!loading">
                          <v-icon>mdi-paperclip</v-icon>
                          Importer ICI ou Glisser/Copier le fichier Excel ci-dessous
                        </v-btn>
                        <input @change="onFilePicked($event)" accept="xlsx/*" id="upload"
                               ref="fileInput"
                               style="display:none" type="file"/>
                      </v-card>
                      <v-card>
                        <div class="text-center">
                          <v-card-text>
                            <v-chip color="white" disabled label small
                                    v-if="file">
                              {{ file.name }} ({{ file.size | kb }} kb)
                            </v-chip>
                            <v-btn @click="removeFile(file)"
                                   title="Supprimer"
                                   v-if="file">
                              <v-icon style="color:mediumvioletred;">
                                mdi-delete-circle-outline
                              </v-icon>
                            </v-btn>
                            <template>
                              <div ref="others">
                                <div :class="['downbox', drag_over ? 'over' : '']"
                                     @dragenter="dragEnter"
                                     @dragleave="dragLeave"
                                     @dragover.prevent
                                     @drop.prevent="addFile"
                                     @ondragover="dragOver"
                                     v-cloak>
                                  <v-btn
                                      color="primary"
                                      height="100px"
                                      outlined
                                      v-if="!file"
                                      width="100%"
                                  >
                                  </v-btn>
                                </div>
                              </div>
                              <v-spacer></v-spacer>
                              <v-btn :disabled="loading" :loading="loading"
                                     @click.prevent="importFileToHandsonTable"
                                     color="#009688" dark
                                     depressed
                                     fab
                                     v-if="file">
                                <v-icon>mdi-cloud-upload</v-icon>
                                <span class="custom-loader" slot="loader">
                                                                        <v-icon color="white" light>cached</v-icon>
                                                                        </span>
                              </v-btn>
                            </template>
                          </v-card-text>
                        </div>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';
import Handsontable from "handsontable";
import Vue from "vue";
import EventBus from '../../../store/event-bus.js'

function customDropDownRender(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.AutocompleteRenderer.apply(this, arguments);
  cellProperties.data = 'options';
  cellProperties.type = 'dropdown';

  if (col === 5) {
    cellProperties.source = window.getCachedBrigades ? window.getCachedBrigades() : [];
  } else {
    cellProperties.source = window.getCachedRoles ? window.getCachedRoles() : [];
  }
}

Vue.filter('kb', val => {
  return Math.floor(val / 1024);
});

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "agents",
  components: {HotTable},
  data: function () {
    return {
      cachedBrigadesList: null,
      cachedRolesList: null,
      companiesLoading: false,
      companiesLoaded: false,
      searchDebouncer: null,
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      modifier: "",
      typeS: null,
      fileBtn: true,
      drag_over: false,   // dragging over the target OR any child element
      over_others: false, // dragging over a child element
      files: [],
      lastHighlitedRow: null,
      menu: null,
      type: null,
      elapse: null,
      loading: false,
      loading2: false,
      toObject: [],
      companies: [],
      dialogModif: false, // AJOUTÉ: Pour remplacer le modal
      editedItem: {
        id: "",
        brigade: "",
        fonction: "",
        userId: "",
        userIdOld: "",
        pinCodeCarte: "",
        accountFirstname: "",
        accountLastname: "",
        accountAddress: "",
        accountPhonenumber: "",
        accountEmail: "",
        accountPassword: "",
        userRoles: "",
        disabled: false,
        listIdEndPoints: "",
        originUser: "",
        creationDate: "",
        walletCompanyId: "",
        walletCardId: "",
        walletId: "",
        realAccountEmail: "",
        serialNumberCard: "",
        serialTag: "",
        bkpmdp: "",
        modified: "",
        revisedDate: "",
        revisedUser: ""
      },
      show1: false,
      e6: 1,
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      errors: [],
      excelData: [],
      brigadetypes: [],
      absencetypes: [],
      roles: [],
      arrayAbs: [],
      hotSettings: {
        renderAllRows: false,
        viewportRowRenderingOffset: 50, // Au lieu de 'auto'
        viewportColumnRenderingOffset: 10,
        // Optimisations de performance
        preventOverflow: 'horizontal',
        preventWheel: false,
        disableVisualSelection: false,
        // Moins de listeners
        observeChanges: false,
        // Cache des renderers
        persistentState: true,
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: {
          items: {
            modifier: {
              name: "Modifier",
              callback(key, selection, clickEvent) { // Callback for specific option
                setTimeout(() => {
                  let start = selection[0].start
                  window.displayTitleModif(start.row)
                  window.updateData4Modif(start.row)
                  window.showModif() // CHANGÉ: Utilise showModif au lieu de show
                }, 0);
              }
            },
            sp1: '---------',
            remove_row: {
              name: "Supprimer"
            }
          }
        },
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        afterChange: this.afterChangeMe,
        afterOnCellMouseDown: this.afterOnCellMouseDownMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        beforeDestroy: this.beforeDestroy,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        afterUpdateSettings: this.afterUpdateSettings,
        afterRender: this.afterRender,
        afterInit: this.afterInit,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0, 2, 7, 8, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
          indicators: false
        },
        colHeaders: [
          "Id", "Nouveau matricule", "Ancien matricule", "Nom", "Prénom", "Brigade", "Fonction",
          "Actif", "Mot de Passe", "Adresse", "Téléphone", "Email", "Date création", "walletCompanyId",
          "walletCardId", "walletId", "pinCodeCarte", "realAccountEmail", "serialNumberCard",
          "serialTag", "bkpmdp", "modified", "originUser", "revisedDate", "revisedUser"
        ],
        columns: [
          {title: "Id", width: "80px", readOnly: true},
          {title: "Nouveau matricule", width: "180px", readOnly: true},
          {title: "Ancien matricule", width: "180px", readOnly: true},
          {title: "Nom", width: "160px", readOnly: true},
          {title: "Prénom", width: "200px", readOnly: true},
          {
            title: "Brigade",
            width: "160px",
            type: "dropdown",
            renderer: customDropDownRender,
            allowInvalid: false,
            strict: true
          },
          {
            title: "Fonction",
            width: "280px",
            type: "dropdown",
            renderer: customDropDownRender,
            allowInvalid: false,
            strict: true
          },
          {title: "Actif", width: "75px", type: "checkbox", readOnly: true},
          {title: "Mot de Passe", width: "130px", type: 'password', hashLength: 6},
          {title: "Adresse", width: "250px"},
          {title: "Téléphone", width: "100px"},

          {title: "Email", width: "250px"},
          {
            title: "Date création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
          {title: "walletCompanyId", width: "100px"},
          {title: "walletCardId", width: "100px"},
          {title: "walletId", width: "100px"},
          {title: "pinCodeCarte", width: "100px"},
          {title: "realAccountEmail", width: "250px"},
          {title: "serialNumberCard", width: "100px"},
          {title: "serialTag", width: "100px"},
          {title: "bkpmdp", width: "100px"},
          {title: "modified", width: "75px", type: "checkbox"},
          {title: "originUser", width: "100px"},
          {
            title: "revisedDate",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date"
          },
          {title: "revisedUser", width: "100px"}
        ],
        cells: function (row, col, prop) {
          const cellProperties = {};
          let str1, str2;

          if (col === 5) {
            str1 = this.instance.getSourceDataAtCell(row, 5)
            if (!(!str1 || /^\s*$/.test(str1))) {
              str1 = str1.toUpperCase()
              str2 = 'INACTIF'
              cellProperties.readOnly = str1.localeCompare(str2) === 0;
            } else {
              cellProperties.readOnly = false;
            }
          }

          return cellProperties;
        }
      },
    }
  },
  watch: {
    searchName: {
      handler(newVal) {
        if (this.searchDebouncer) {
          clearTimeout(this.searchDebouncer);
        }
        this.searchDebouncer = setTimeout(() => {
          this.search();
        }, 300); // Attendre 300ms après la dernière frappe
      }
    }
  },
  created() {
    this.getData()
    this.loadRoles()
    this.loadBrigades()
    this.initEditedItem()
    this.getCompanies() // Ajouter cette ligne
  },
  mounted() {
    // CHANGÉ: Ajout de showModif et closeModif
    window.showModif = this.showModif;
    window.displayTitleModif = this.displayTitleModif;
    window.updateData4Modif = this.updateData4Modif;
    // AJOUTEZ ces 2 lignes :
    window.getCachedBrigades = this.getCachedBrigades;
    window.getCachedRoles = this.getCachedRoles;
  },
  computed: {
    FormIsValid() {
      return (
          this.editedItem.userId !== "" &&
          !!this.editedItem.walletCompanyId &&
          this.editedItem.userRoles !== "" &&
          this.editedItem.realAccountEmail !== "" &&
          this.editedItem.brigade !== ""
      );
    },
    FormIsValidModif() {
      return (
          this.editedItem.userId !== "" &&
          !!this.editedItem.walletCompanyId &&
          this.editedItem.userRoles !== "" &&
          this.editedItem.brigade !== "" &&
          this.editedItem.realAccountEmail !== ""
      );
    },
    userRole() {
      return this.$store.getters.user.role;
    }
  },
  methods: {
    // Ajouter cette configuration pour améliorer l'accessibilité
    afterUpdateSettings() {
      // Retirer aria-hidden des éléments de saisie
      const input = document.querySelector('.handsontableInput');
      if (input) {
        input.removeAttribute('aria-hidden');
      }
    },

    afterInit() {
      // Retirer aria-hidden lors de l'initialisation
      const input = document.querySelector('.handsontableInput');
      if (input) {
        input.removeAttribute('aria-hidden');
      }
    },

    afterRender() {
      // Retirer aria-hidden après chaque rendu
      const input = document.querySelector('.handsontableInput');
      if (input) {
        input.removeAttribute('aria-hidden');
      }
    },

    // Nouvelles méthodes de cache avec des noms uniques
    getCachedBrigades() {
      if (!this.cachedBrigadesList) {
        this.cachedBrigadesList = JSON.parse(sessionStorage.getItem("Brigades")) || [];
      }
      return this.cachedBrigadesList;
    },

    getCachedRoles() {
      if (!this.cachedRolesList) {
        this.cachedRolesList = JSON.parse(sessionStorage.getItem("Roles")) || [];
      }
      return this.cachedRolesList;
    },

    invalidateBrigadesCache() {
      this.cachedBrigadesList = null; // ✅ Correct (était cachedBrigades)
    },

    invalidateRolesCache() {
      this.cachedRolesList = null; // ✅ Correct (était cachedRoles)
    },

    async getCompanies() {
      // Éviter les appels multiples
      if (this.companiesLoading || this.companiesLoaded) {
        return this.companies;
      }

      this.companiesLoading = true;

      try {
        const response = await apiClient.get(
            `${this.$store.getters.user.baseUrl}/wallet/get_wallet_only_companies/` +
            sessionStorage.getItem("accountId")
        );

        if (response.data.status === 200) {
          this.companies = response.data.datas.map(company => ({
            id: company.id,
            name: company.name
          }));
          this.companiesLoaded = true;
          return this.companies;
        } else {
          throw new Error(response.data.message);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des entreprises:", error);
        this.companies = [];
        throw error;
      } finally {
        this.companiesLoading = false;
      }
    },

    validateUserData(data) {
      const errors = [];

      if (!data.userId || data.userId.trim() === '') {
        errors.push('Matricule requis');
      }

      if (!data.walletCompanyId) {
        errors.push('Entreprise requise');
      }

      if (!data.userRoles || data.userRoles.trim() === '') {
        errors.push('Fonction requise');
      }

      if (!data.realAccountEmail || !this.isValidEmail(data.realAccountEmail)) {
        errors.push('Email valide requis');
      }

      return errors;
    },

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    async displayTitleModif(row) {
      // Attendre que les entreprises soient chargées si nécessaire
      if (this.companies.length === 0) {
        await this.getCompanies();
      }

      String.prototype.capitalize = function (allWords) {
        return (allWords) ?
            this.split(' ').map(word => word.capitalize()).join(' ') :
            this.charAt(0).toUpperCase() + this.slice(1);
      }

      let rowT = this.$refs.hotTable.hotInstance.getData()[row]
      this.modifier = "Modifications agent " + rowT[3].toUpperCase() + " " + rowT[4].toLowerCase().capitalize(true);
    },
    async updateData4Modif(row) {
      // Attendre que les entreprises soient chargées si nécessaire
      if (this.companies.length === 0) {
        await this.getCompanies();
      }

      let rowT = this.$refs.hotTable.hotInstance.getData()[row]

      this.editedItem.id = rowT[0];
      this.editedItem.userId = rowT[1];
      this.editedItem.userIdOld = rowT[2];
      this.editedItem.accountLastname = rowT[3];
      this.editedItem.accountFirstname = rowT[4];
      this.editedItem.brigade = rowT[5];
      this.editedItem.userRoles = rowT[6];
      this.editedItem.disabled = rowT[7];
      this.editedItem.accountAddress = rowT[9];
      this.editedItem.accountPhonenumber = rowT[10];
      this.editedItem.accountEmail = rowT[11];
      this.editedItem.creationDate = rowT[12];
      this.editedItem.walletCompanyId = rowT[13];
      this.editedItem.walletCardId = rowT[14];
      this.editedItem.walletId = rowT[15];
      this.editedItem.pinCodeCarte = rowT[16];
      this.editedItem.realAccountEmail = rowT[17];
      this.editedItem.accountPassword = rowT[8];
      this.editedItem.serialNumberCard = rowT[18];
      this.editedItem.serialTag = rowT[19];
      this.editedItem.bkpmdp = rowT[20];
      this.editedItem.modified = rowT[21];
      this.editedItem.originUser = rowT[22];
      this.editedItem.revisedDate = rowT[23];
      this.editedItem.revisedUser = rowT[24];
    },
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 1, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    // REMPLACÉ: Nouvelles méthodes pour v-dialog
    showModif() {
      this.dialogModif = true;
    },
    closeModif() {
      this.dialogModif = false;
      this.initEditedItem();
    },
    init() {
      this.tab = "tab-1";
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
      this.initEditedItem();
      this.refresh();
    },
    dragEnter(e) {
      if (e.target === this.$refs.others)
        this.over_others = true
      else
        this.drag_over = true
    },
    dragOver(e) {
      if (e.target === this.$refs.others) this.over_others = true
      else this.drag_over = true
    },
    dragLeave(e) {
      if (e.target === this.$refs.others) this.over_others = false
      else if (!this.over_others) this.drag_over = false
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    getData() {
      this.loading = true

      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/users/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                item["userId"],
                item["userIdOld"],
                this.isEmpty(item["accountLastname"]) ? "" : item["accountLastname"].toUpperCase(),
                this.isEmpty(item["accountFirstname"]) ? "" : item["accountFirstname"].toLowerCase().capitalize(true),
                this.isEmpty(item["brigade"]) ? "" : item["brigade"].toUpperCase(),
                this.isEmpty(item["userRoles"]) ? "" : item["userRoles"].toUpperCase(),
                !item["disabled"],
                item["accountPassword"],
                item["accountAddress"],
                item["accountPhonenumber"],
                this.isEmpty(item["accountEmail"]) ? "" : item["accountEmail"].toLowerCase(),
                this.datefull(item["creationDate"]),
                item["walletCompanyId"],
                item["walletCardId"],
                item["walletId"],
                item["pinCodeCarte"],
                item["realAccountEmail"],
                item["serialNumberCard"],
                item["serialTag"],
                item["bkpmdp"],
                item["modified"],
                item["originUser"],
                this.datefull(item["revisedDate"]),
                item["revisedUser"]
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
          })
          .catch(() => {
            this.loading = false
          });
    },
    async loadBrigades() {
      try {
        const response = await apiClient.get(
            `${this.$store.getters.user.baseUrl}/account/brigadetypes/` +
            sessionStorage.getItem("userId")
        );

        this.brigadetypes = []; // Garder votre logique existante
        const datas = response.data.datas;
        datas.forEach(item => {
          if (item.type.toUpperCase() !== "INACTIF") {
            this.brigadetypes.push(item.type);
          }
        });

        sessionStorage.setItem("Brigades", JSON.stringify(this.brigadetypes));

        // Invalider le cache
        this.cachedBrigadesList = null;

      } catch (error) {
        console.error('Erreur lors du chargement des brigades:', error);
        this.brigadetypes = [];
        sessionStorage.setItem("Brigades", JSON.stringify([]));
        this.cachedBrigadesList = null;
      }
    },

    async loadRoles() {
      try {
        const response = await apiClient.get(
            `${this.$store.getters.user.baseUrl}/account/roles/` +
            sessionStorage.getItem("userId")
        );

        let datas = response.data.datas;
        let ArrayRoles = [];
        datas.forEach(item => {
          if (item.roleName !== "ADMINISTRATOR" &&
              item.roleName !== "FRONT" &&
              item.roleName !== "USER" &&
              item.roleName !== "READER") {
            ArrayRoles.push(item.roleName);
          }
        });

        this.roles = ArrayRoles; // Garder votre logique existante
        sessionStorage.setItem("Roles", JSON.stringify(ArrayRoles));

        // Invalider le cache
        this.cachedRolesList = null;

      } catch (error) {
        console.error('Erreur lors du chargement des rôles:', error);
        this.roles = [];
        sessionStorage.setItem("Roles", JSON.stringify([]));
        this.cachedRolesList = null;
      }
    },

    beforeDestroy() {
      // Nettoyer les timers
      if (this.searchDebouncer) {
        clearTimeout(this.searchDebouncer);
      }

      if (this.showAlert.timer) {
        clearTimeout(this.showAlert.timer);
      }

      if (this.showAlert.t) {
        clearInterval(this.showAlert.t);
      }

      // Nettoyer Handsontable
      if (this.$refs.hotTable && this.$refs.hotTable.hotInstance) {
        this.$refs.hotTable.hotInstance.destroy();
      }

      // Nettoyer les références window
      window.getCachedBrigades = null;
      window.getCachedRoles = null;
      window.showModif = null;
      window.displayTitleModif = null;
      window.updateData4Modif = null;
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData()
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    convertDate(val) {
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY");
    },
    close() {
      this.dialog = false;
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
      this.initEditedItem();
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type, message = this.text, isDialog = false) {
      this.text = message;

      if (isDialog) {
        this.typeS = type;
      } else {
        this.type = type;
      }

      // Nettoyer les timers existants
      if (this.showAlert.timer) {
        clearTimeout(this.showAlert.timer);
      }
      if (this.showAlert.t) {
        clearInterval(this.showAlert.t);
      }

      // Nouveau timer
      this.showAlert.timer = setTimeout(() => {
        if (type === "info" && isDialog) {
          this.closeModif();
        }
        if (isDialog) {
          this.typeS = null;
        } else {
          this.type = null;
        }
      }, 20000);

      // Compteur visuel
      this.elapse = 1;
      this.showAlert.t = setInterval(() => {
        if (this.elapse === (isDialog ? 4 : 3)) {
          this.elapse = 0;
          clearInterval(this.showAlert.t);
        } else {
          this.elapse++;
        }
      }, 5000);
    },
    AlertColorS(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlertS(type) {
      this.typeS = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        if (this.typeS === "info") {
          this.closeModif() // CHANGÉ: Utilise closeModif au lieu de hide
        }
        this.typeS = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 4) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification du compte.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              this.loading = true;
              let obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]];

              if (changes[0][1] === 7) {
                // Gestion Actif/Inactif
                let urlTmp = changes[0][3] === true
                    ? `${this.$store.getters.user.baseUrl}/account/user/enable/${obj[0]}/${sessionStorage.getItem("userId")}`
                    : `${this.$store.getters.user.baseUrl}/account/user/disable/${obj[0]}/${sessionStorage.getItem("userId")}`;

                apiClient
                    .post(urlTmp)
                    .then(res => {
                      this.loading = false;
                      if (res.data.status === 200) {
                        this.showAlert('info', res.data.message);
                      } else {
                        this.revertChange(changes);
                        this.showAlert('warning', res.data.message);
                      }
                    })
                    .catch(err => {
                      this.loading = false;
                      this.revertChange(changes);
                      this.showAlert('warning', err.data?.message || 'Erreur');
                    })
                    .finally(() => {
                      dialog.close(); // ✅ TOUJOURS fermer la dialog
                    });

              } else if (changes[0][1] === 8) {
                // Gestion mot de passe
                let urlTmp = `${this.$store.getters.user.baseUrl}/account/user/password/${obj[0]}/${obj[8]}/${sessionStorage.getItem("userId")}`;

                apiClient
                    .post(urlTmp)
                    .then(res => {
                      this.loading = false;
                      if (res.data.status === 200) {
                        this.showAlert('info', res.data.message);
                      } else {
                        this.showAlert('warning', res.data.message);
                      }
                    })
                    .catch(err => {
                      this.loading = false;
                      this.showAlert('warning', err.data?.message || 'Erreur');
                    })
                    .finally(() => {
                      dialog.close(); // ✅ TOUJOURS fermer la dialog
                    });

              } else {
                // Gestion modification générale
                let newObj = {
                  "id": obj[0],
                  "userId": obj[1],
                  "userIdOld": obj[2],
                  "accountLastname": obj[3],
                  "accountFirstname": obj[4],
                  "brigade": obj[5],
                  "userRoles": obj[6],
                  "disabled": !obj[7],
                  "accountAddress": obj[9],
                  "accountPhonenumber": obj[10],
                  "walletCompanyId": obj[13],
                  "walletCardId": obj[14],
                  "walletId": obj[15],
                  "realAccountEmail": obj[17],
                  "serialNumberCard": obj[18],
                  "serialTag": obj[19],
                  "bkpmdp": obj[20],
                  "modified": obj[21],
                  "originUser": obj[22],
                  "revisedUser": sessionStorage.getItem("userId")
                };

                apiClient
                    .post(`${this.$store.getters.user.baseUrl}/account/user/${sessionStorage.getItem("userId")}`, newObj)
                    .then(res => {
                      this.loading = false;
                      if (res.data.status === 200) {
                        this.showAlert('info', res.data.message);
                        this.getData();
                      } else {
                        this.revertChange(changes);
                        this.showAlert('warning', res.data.message);
                      }
                    })
                    .catch(err => {
                      this.loading = false;
                      this.revertChange(changes);
                      this.showAlert('warning', err.data?.message || 'Erreur');
                    })
                    .finally(() => {
                      dialog.close(); // ✅ TOUJOURS fermer la dialog
                    });
              }
            })
            .catch(() => {
              // Utilisateur a annulé - dialog se ferme automatiquement
              this.revertChange(changes);
            });
      }
    },

    revertChange(changes) {
      const myData = this.$refs.hotTable.hotInstance.getData();
      myData[changes[0][0]][changes[0][1]] = changes[0][2];
      this.$refs.hotTable.hotInstance.loadData(myData);
    },

    beforeRemoveRowMe(index, amount) {
      let rowId = this.$refs.hotTable.hotInstance.getData()[index];
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression du compte.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true;

            apiClient
                .delete(`${this.$store.getters.user.baseUrl}/account/user/${rowId[0]}/${sessionStorage.getItem("userId")}`)
                .then(res => {
                  this.loading = false;
                  if (res.data.status === 200) {
                    this.showAlert('info', res.data.message);
                  } else {
                    this.restoreDeletedRow(index, rowId);
                    this.showAlert('warning', res.data.message);
                  }
                })
                .catch(error => {
                  this.loading = false;
                  this.restoreDeletedRow(index, rowId);
                  this.showAlert('warning', 'Erreur lors de la suppression');
                })
                .finally(() => {
                  dialog.close(); // ✅ TOUJOURS fermer la dialog
                });
          })
          .catch(() => {
            // Utilisateur a annulé
            this.restoreDeletedRow(index, rowId);
          });
    },

// Ajoutez cette méthode helper:
    restoreDeletedRow(index, rowData) {
      this.$refs.hotTable.hotInstance.alter("insert_row_above", index);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 12, "readOnly", false);
      this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowData]);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 12, "readOnly", true);
    },
    onFilePicked(e) {
      const files = e.target.files;
      this.file = this.$refs.fileInput.files[0];
      if (!files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.text = "Le format du fichier est incorrecte.\nMerci de choisir un format xls ou xlsx";
        this.showAlert('warning');
        return false;
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {defval: "", skipHidden: true});
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.total = excellist
              .map(item => item.montant)
              .reduce((prev, curr) => prev + curr, 0);
          this.excelData = excellist.map(function (item) {
            return Object.values(item);
          })
        } catch (e) {
          this.text = "Erreur de lecture du fichier !";
          this.showAlert('warning')
          return false;
        }
      }
      fileReader.readAsBinaryString(files[0]);
      const input = document.getElementById("upload");
      input.value = "";
    },
    initEditedItem() {
      this.editedItem.id = this.editedItem.userId =
          this.editedItem.accountLastname = this.editedItem.accountFirstname =
              this.editedItem.brigade = this.editedItem.userRoles =
                  this.editedItem.startWorkingDate = this.editedItem.disabled =
                      this.editedItem.accountAddress = this.editedItem.accountPhonenumber =
                          this.editedItem.accountEmail = this.editedItem.serialNumberCard =
                              this.editedItem.originUser = this.editedItem.creationDate =
                                  this.editedItem.pinCodeCarte = this.editedItem.accountPassword =
                                      this.editedItem.walletCompanyId = this.editedItem.walletCardId =
                                          this.editedItem.walletId = this.editedItem.realAccountEmail =
                                              this.editedItem.serialNumberCard = this.editedItem.serialTag =
                                                  this.editedItem.bkpmdp = this.editedItem.modified =
                                                      this.editedItem.revisedDate = this.editedItem.originUser = "";
    },
    creer(modifier) {
      this.loading = true;

      const dataToSave = {
        // Champs existants (gardez-les)
        id: this.isEmpty(this.editedItem.id) ? null : this.editedItem.id,
        userId: this.editedItem.userId,
        walletCompanyId: this.editedItem.walletCompanyId,
        accountLastname: this.editedItem.accountLastname,
        accountFirstname: this.editedItem.accountFirstname,
        brigade: this.editedItem.brigade,
        userRoles: this.editedItem.userRoles,
        disabled: false,
        accountAddress: this.editedItem.accountAddress,
        accountPhonenumber: this.editedItem.accountPhonenumber,
        realAccountEmail: this.editedItem.realAccountEmail,

        // ✅ AJOUT des champs manquants:
        userIdOld: this.editedItem.userIdOld !== undefined ? this.editedItem.userIdOld : null,
        walletCardId: this.editedItem.walletCardId !== undefined ? this.editedItem.walletCardId : null,
        walletId: this.editedItem.walletId !== undefined ? this.editedItem.walletId : null,
        serialNumberCard: this.editedItem.serialNumberCard !== undefined ? this.editedItem.serialNumberCard : null,
        serialTag: this.editedItem.serialTag !== undefined ? this.editedItem.serialTag : null,
        bkpmdp: this.editedItem.bkpmdp !== undefined ? this.editedItem.bkpmdp : null,
        modified: this.editedItem.modified !== undefined ? this.editedItem.modified : false,

        // ✅ Logique pour originUser vs revisedUser:
        originUser: modifier === true ? null : sessionStorage.getItem("userId"),  // Pour création
        revisedUser: modifier === true ? sessionStorage.getItem("userId") : null  // Pour modification
      };

      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/account/user/${sessionStorage.getItem("userId")}`,
              dataToSave
          )
          .then(res => {
            this.loading = false;
            if (res.data.status === 200) {
              this.color = "#009688";
              this.text = res.data.message;
              this.dialog = false;
              this.getData();

              if (!this.isEmpty(this.editedItem.id)) {
                this.closeModif();
              }
              this.initEditedItem();
              this.showAlert('info');
            } else {
              this.alert = true;
              this.color = "#F44336";
              this.text = res.data.message;
              this.dialog = false;

              if (!this.isEmpty(this.editedItem.id)) {
                this.showAlertS('warning');
              } else {
                this.showAlert('warning');
              }
            }
          })
          .catch(err => {
            this.alert = true;
            this.text = err.message || err;
            this.dialog = false;
            this.loading = false;
            this.color = "#F44336";

            if (!this.isEmpty(this.editedItem.id)) {
              this.showAlertS('warning');
            } else {
              this.showAlert('warning');
            }
          });
    },
    importFileToHandsonTable() {
      const vm = this;
      vm.loading = true
      vm.dialog = false;
      vm.file = ""
      let dataTosave = [];

      for (let i = 0; i < this.excelData.length; i++) {
        dataTosave.push({
          userId: this.excelData[i][0],
          accountLastname: this.excelData[i][1],
          accountFirstname: this.excelData[i][2],
          brigade: this.excelData[i][3],
          userRoles: this.excelData[i][4],
          accountEmail: this.excelData[i][5],
          accountPassword: this.excelData[i][6],
          pinCodeCarte: this.excelData[i][7],
          accountAddress: this.excelData[i][8],
          accountPhonenumber: this.excelData[i][9],
          disabled: false,
          originUser: sessionStorage.getItem("userId")
        });
      }

      apiClient
          .post(
              `${vm.$store.getters.user.baseUrl}/account/users/` +
              sessionStorage.getItem("userId"),
              dataTosave
          )
          .then(res => {
            vm.loading = false
            if (res.data.status === 200) {
              let dataObj = []
              let dataError = []
              for (let i = 0; i < res.data.datas.length; i++) {
                if (res.data.datas[i].status === 200) {
                  dataObj.push(res.data.datas[i].datas);
                } else {
                  dataError.push(res.data.datas[i]);
                }
              }

              if (dataObj.length > 0 && dataError.length === 0) {
                vm.color = "#009688"
                vm.text = dataObj.length + " Agent(s) ajouté(s)."
                vm.file = "";
                this.showAlert('info')
                this.getData()
              } else if (dataObj.length === 0 && dataError.length > 0) {
                vm.alert = true
                vm.color = "#F44336"
                vm.errors = dataError
                vm.file = "";
                this.getData()
              } else if (dataObj.length > 0 && dataError.length > 0) {
                vm.color = "#F44336"
                vm.errors = dataError
                vm.file = "";
                vm.alert = true
                this.getData()
              }
            }
          })
          .catch(err => {
            vm.alert = true
            vm.text = err;
            vm.loading = false;
            vm.dialog = false;
            vm.color = "#F44336"
            this.showAlert('warning')
          });
    },

    onexport() { // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      this.loading = true
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true})
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Agents") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Agents.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },

    onexportModele() { // On Click Excel download button
      this.loading = true

      var ws = XLSX.utils.json_to_sheet([
        {
          userId: "Matricule",
          accountLastname: "Nom",
          accountFirstname: "Prénoms",
          brigade: "Brigade",
          userRoles: "Fonction",
          accountEmail: "Email",
          accountPassword: "Mot de passe",
          pinCodeCarte: "Code pin carte",
          accountAddress: "Adresse",
          accountPhonenumber: "Téléphone"
        },
        {
          userId: "15002",
          accountLastname: "Fall",
          accountFirstname: "Modou Ahmed",
          brigade: "TSA",
          userRoles: "FORMATEUR",
          accountEmail: "15002@teranga-sa.com",
          accountPassword: "terangasa15002",
          pinCodeCarte: "7896",
          accountAddress: "Dieuppeul 3",
          accountPhonenumber: "775896565"

        },
      ], {
        header: ["userId", "accountLastname", "accountFirstname", "brigade", "userRoles", "accountEmail",
          "accountPassword", "pinCodeCarte", "accountAddress", "accountPhonenumber"],
        skipHeader: true,
        cellDates: true
      });

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, ws, "Agents_Modèle") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Agents_modèle.xlsx", {cellDates: true}) // name of the file is "book.xlsx"
      this.loading = false
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
      ([...droppedFiles]).forEach(f => {
        this.files.push(f);
      });

      let formData = new FormData();
      this.files.forEach((f, x) => {
        formData.append('file' + (x + 1), f);
      });

      if (!this.files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(this.files[0].name.toLowerCase())) {
        this.text = "Le format du fichier est incorrecte.\nMerci de choisir un format xls ou xlsx";
        this.showAlert('warning');
        return false;
      } else if (this.files.length !== 1) {
        this.text = "Nous ne traitons qu'un fichier excel";
        this.showAlert('warning');
        return false;
      }

      this.file = this.files[0];
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {defval: "", skipHidden: true});
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.total = excellist
              .map(item => item.montant)
              .reduce((prev, curr) => prev + curr, 0);
          this.excelData = excellist.map(function (item) {
            return Object.values(item);
          })

          this.fileBtn = false;
        } catch (e) {
          this.text = "Erreur de lecture du fichier !";
          this.showAlert('warning')
          return false;
        }
      }
      fileReader.readAsBinaryString(this.file);
      const input = document.getElementById("upload");
      input.value = "";
    },
    removeFile(file) {
      this.loading = false
      this.fileBtn = true
      this.drag_over = false
      this.file = ""
      this.files = this.files.filter(f => {
        return f !== file;
      });
    },
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

/* Centrage unifié - remplace tous les styles répétitifs */
.centered-input input,
.centered-input .v-select__selections {
  text-align: center !important;
  justify-content: center !important;
}

.centered-input .v-select__selection {
  text-align: center !important;
  margin: 0 auto !important;
}

.centered-input .v-label,
.centered-input.v-text-field .v-label,
.centered-input.v-select .v-label,
.centered-input.v-input--is-disabled .v-label,
.v-stepper .centered-input .v-label,
.align-center .v-label,
.text-center .v-label {
  text-align: center !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  right: auto !important;
}

.centered-input.v-input--is-label-active .v-label,
.v-stepper .centered-input.v-input--is-label-active .v-label {
  transform: translateX(-50%) translateY(-18px) scale(0.75) !important;
  position: absolute !important;
  left: 50% !important;
}
</style>